import React from 'react';

const Icon16OrientationRight = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <path
      d="M291.63,283.66h216.75v202.3c0,7.98-6.47,14.45-14.45,14.45h-187.85c-7.98,0-14.45-6.47-14.45-14.45v-202.3h0Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M508.37,231.42h216.75v369.66c0,7.98-6.47,14.45-14.45,14.45h-187.85c-7.98,0-14.45-6.47-14.45-14.45V231.42h0Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M725.12,231.42h32.67c5.07,0,9.18,4.11,9.18,9.18v250.64c0,5.07-4.11,9.18-9.18,9.18h-23.49c-5.07,0-9.18-4.11-9.18-9.18V231.42h0Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="291.63"
      y="231.42"
      width="216.75"
      height="52.25"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M74.88,283.66h216.75v202.3c0,7.98-6.47,14.45-14.45,14.45H89.33c-7.98,0-14.45-6.47-14.45-14.45v-202.3h0Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <path
      d="M42.2,231.42h32.67v259.82c0,5.07-4.11,9.18-9.18,9.18h-23.49c-5.07,0-9.18-4.11-9.18-9.18v-250.64c0-5.07,4.11-9.18,9.18-9.18Z"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="74.88"
      y="231.42"
      width="216.75"
      height="52.25"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
    <rect
      x="508.37"
      y="231.42"
      width="216.75"
      height="52.25"
      fill="transparent"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="10"
    />
  </svg>
);

export default Icon16OrientationRight;
